import { useCallback, useEffect } from "react"
import { isElectronApp } from "./electron"

export const usePreventPageUnload = (onBeforeUnload?: () => Promise<void>) => {
	const beforeUnloadListener = useCallback(
		(event: BeforeUnloadEvent) => {
			if (import.meta.env.DEV) {
				return
			}

			void onBeforeUnload?.()

			// Do not prevent page unload on Electron
			if (isElectronApp) {
				return
			}

			// Both preventDefault and returnValue are needed.
			// See: https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event#compatibility_notes
			event.preventDefault()
			return (event.returnValue = "")
		},
		[onBeforeUnload],
	)

	useEffect(() => {
		addEventListener("beforeunload", beforeUnloadListener, {
			capture: true,
		})

		return () => {
			removeEventListener("beforeunload", beforeUnloadListener, {
				capture: true,
			})
		}
	}, [beforeUnloadListener])
}
export const usePageUnload = (onUnload: () => Promise<void>) => {
	const unloadListener = useCallback(() => {
		void onUnload()
	}, [onUnload])

	useEffect(() => {
		addEventListener("unload", unloadListener, {
			capture: true,
		})

		return () => {
			removeEventListener("unload", unloadListener, {
				capture: true,
			})
		}
	}, [unloadListener])
}
